import * as React from "react";
import type { SVGProps } from "react";
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 4v16"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.5 9.5H20a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1.5A2.5 2.5 0 0 1 16 12v0a2.5 2.5 0 0 1 2.5-2.5"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 14.5v3a2.5 2.5 0 0 1-2.5 2.5h-12A2.5 2.5 0 0 1 3 17.5v-11A2.5 2.5 0 0 1 5.5 4h12A2.5 2.5 0 0 1 20 6.5v3"
    />
  </svg>
);
export default SvgWallet;
